var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"version-item\">\n    <div class=\"image-container\"><img class=\"empty\"></div>\n    <div class=\"info\">\n        <a href=\"#\" class=\"btn btn-yellow action\" data-action=\"loadversion\" data-version=\""
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"version") : depth0)) != null ? lookupProperty(stack1,"versionId") : stack1), depth0))
    + "\">"
    + alias2(__default(require("../../../../../../../src/utils/handlebars-helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"top_submenu.versions.load",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":4,"column":115},"end":{"line":4,"column":148}}}))
    + "</a>\n        <div>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"time_since") : depth0), depth0))
    + "</div>\n    </div>\n</div>\n";
},"useData":true});